import React from 'react';
import { Split } from '../../Split';
import {
  ChosenWordExplanation, StyledWordExplainer, WordContainer, StyledLabel,
} from './styles';

type WordExplainerProps = {
  title: String,
  subTitle: String,
  dependData: Array,
  answer: Array,
  setAnswer: Function,
};

const WordExplainer = ({
  answer = {},
  setAnswer,
  title,
  subTitle,
  dependData,
}: WordExplainerProps) => (
  <Split width={100}>
    <h2 className="question-heading">{title}</h2>
    <p className="question-description">{subTitle}</p>
    <WordContainer>
      {dependData.map(word => (
        <StyledWordExplainer>
          <ChosenWordExplanation>
            <StyledLabel>
              {word}
              <input
                value={answer[word]}
                id="explenation"
                type="text"
                onChange={(e) => {
                  const explenation = e.target.value;
                  const newValue = { ...answer, [word]: explenation };

                  setAnswer(
                    newValue,
                    Object.keys(newValue).filter(key => newValue[key] && newValue[key].length > 3)
                      .length === dependData.length,
                  );
                }}
              />
            </StyledLabel>
          </ChosenWordExplanation>
        </StyledWordExplainer>
      ))}
    </WordContainer>
  </Split>
);
export default WordExplainer;
